import React from "react";
import db, { auth, googleProvider } from "./firebase";
import { useNavigate } from "react-router-dom";
import "./Login.css";

function Login({setUser}) {
  const navigate = useNavigate();


  const signInWithGoogle =()=>{
    auth.signInWithPopup(googleProvider)
    .then((result) => {
      const newUser = {
        fullname: result.user.displayName,
        email: result.user.email,
        photoURL: result.user.photoURL,
      };
      navigate('/')
    
      setUser(newUser);
      db.collection('users').doc(result.user.email).set(newUser);

  })
  .catch((err) => alert(err.message))

};
 
  return (
    <div className="login">
      <div className ="login-container">
<img className="login-logo"src ="./Reddit-Logo.png" alt =""/>
<p className="login-name">Reddit</p>
<button className="login-btn" onClick={signInWithGoogle}>
    <img src="./google-logo.png" alt ="login with google"/>
</button>
      </div>
    </div>
  )
}

export default Login
